<template>
  <div class="nav-content">
    <div style="width: 100%; height: 40px;">
      <Button @click="backList" style="float: right;">返回</Button>
    </div>

    <div
      v-if="loading"
      style="font-size: 24px; text-align: center; margin-top: 20px;"
    >
      加载中...
    </div>

    <div v-else>
      <div
        style="
          font-size: 36px;
          font-weight: 600;
          line-height: 50px;
          color: #424242;
          text-align: left;
          margin-top: 20px;
          margin-bottom: 50px;
        "
      >
        {{ this.total }}
      </div>

      <div style="margin-bottom: 70px;">
        <div v-for="(stepItem, stepIndex) in stepList" :key="stepIndex" style="width: 900px;">
          <div
            class="step_box"
            :class="{
              isright: (stepIndex + 1) % 2 === 1, 
              isfirst: stepIndex === 0,
              islast: stepIndex == stepList.length - 1
            }"
          >
            <div v-if="stepIndex != 0" class="flex_1 cover_img">
              <div v-if="stepIndex != 0 && (stepIndex + 1) % 2 === 1" class="leftCiropp">
                <div style="margin-left: 20px; margin-top: 16px;">
                  <div style="overflow: hidden;">
                    <div class="itemTitle1">{{ stepItem.title }}</div>
                    <div class="ywcLeft">已完成</div>
                  </div>
                  <div class="itemData1">{{ stepItem.data }}</div>
                  <div class="itemPerson1">{{ stepItem.person }}</div>
                </div>
              </div>

              <div v-if="stepIndex != 0 && (stepIndex + 1) % 2 === 0" class="rightCiropp">
                <div style="float: right; margin-right: 20px; margin-top: 16px;">
                  <div style="overflow: hidden; margin-bottom: 12px;">
                    <div class="ywcRight">已完成</div>
                    <div class="itemTitle">{{ stepItem.title }}</div>
                  </div>
                  <div class="itemData">{{ stepItem.data }}</div>
                  <div class="itemPerson">{{ stepItem.person }}</div>
                </div>
              </div>
            </div>

            <div class="icon_dot">
              <div v-if="stepIndex == 0" class="firstCiropp">
                <div class="startItem" style="padding-top: 10px;">{{ stepItem.data }}</div>
                <div class="startItem">{{ stepItem.title }}</div>
              </div>
              <div v-else class="yuan"></div>
            </div>

            <div v-if="stepIndex != 0" class="flex_1 cover_text"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "detail",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,       // 加载状态
      total: "",
      stepList: []
    };
  },
  mounted() {
    this.fetchDetail();
  },
  methods: {
    async fetchDetail() {
      try {
        const response = await axios.get(`${window.osConfig.registerUrl}/custom/schedule/getDetail/${this.id}`);
        
        if (response.data.code === 0 && response.data.content) {
          const content = JSON.parse(response.data.content);

          // 映射数据格式并按 order 排序
          this.stepList = content
            .map(item => ({
              data: new Date(item.node_date).toLocaleDateString(),   // 转换时间戳为日期
              title: item.schedule_info,
              person: item.executor,
              order: item.order
            }))
            .sort((a, b) => a.order - b.order);  // 按 order 升序排序

          this.loading = false;
        } else {
          this.$Message.error("获取数据失败");
        }
      } catch (error) {
        console.error("获取数据异常", error);
        this.$Message.error("获取数据异常");
        this.loading = false;
      }
    },
    backList() {
      this.$emit("backList");
    }
  }
};
</script>

<style scoped>
/*css中部分为冗余样式，麻烦所以没删干净*/
.nav-content {
  width: inherit;
  margin: 0 auto;
}

.step_box {
  display: flex;
  justify-content: center;
  height: 150px;
}
.startItem{
      text-align: center;
      color: #222222;
      font-size: 14px;
      font-weight: 600;
    }

    .firstCiropp {
      width: 200px;
      height: 70px;
      border-radius: 8px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      position: relative;
      margin-bottom: 94px;
      border-radius: 20px;
    }
 
    .firstCiropp::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      /*三角形的方向*/
      width: 15px;
      height: 15px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      border-style: none none solid solid
    }


.step_box.isright {
  flex-direction: row-reverse;
  .cover_text {
    text-align: right !important;
  }
}

.step_box.isfirst .icon_dot::after {
  height: 50%;
  bottom: 0;
}

.step_box.islast .icon_dot::after {
  height: 50%;
}

.flex_1 {
  width: 350px;
}

.flex_1.cover_img {
  display: flex;
  align-items: center;
}

.flex_1.cover_text {
  text-align: left;
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}

.icon_dot {
  margin: 0 80px;
  display: flex;
  align-items: center;
  position: relative;
}

.icon_dot::after {
  content: "";
  position: absolute;
  height: 100%;
  width: 1px;
  background: #bcbcbc;
  top: 0;
  left: 0;
  right: 0;
  margin: auto;
}

.yuan {
  width: 12px;
  height: 12px;
  background: #fff;
  z-index: 9;
  display: block;
  margin-bottom: 2px;
}

.firstCiropp {
  width: 200px;
  height: 70px;
  border-radius: 8px;
  background: #fff;
  border: 1px solid #d1d1d1;
  position: relative;
  margin-bottom: 94px;
}

.firstCiropp::after {
  content: "";
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-45deg);
  width: 15px;
  height: 15px;
  background: #fff;
  border: 1px solid #d1d1d1;
}

.itemTitle{
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 18px;
      color: #222222;
      text-align: right;
      float: left;
      max-width: 260px;
      white-space: nowrap;      /* 确保文本在一行内显示 */
      overflow: hidden;         /* 超出容器的文本隐藏 */
      text-overflow: ellipsis
    }
    .itemTitle1{
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 18px;
      color: #222222;
      text-align: right;
      float: left;
      max-width: 260px;
      white-space: nowrap;      /* 确保文本在一行内显示 */
      overflow: hidden;         /* 超出容器的文本隐藏 */
      text-overflow: ellipsis;
      margin-right:8px
    }

    .itemData{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: right;
      margin-bottom: 12px;
    }
    .itemPerson{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: right;
    }
    .itemData1{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: left;
      margin-bottom: 12px;
    }
    .itemPerson1{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: left;
    }


.ywcLeft, .ywcRight {
  width: 32px;
  height: 18px;
  background: #00b55a;
  color: #fff;
  font-size: 12px;
  text-align: center;
  border-radius: 3px;
}

.rightCiropp {
      width: 342px;
      height: 125px;
      border-radius: 8px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      position: relative;
    }
 
    .rightCiropp::after {
      content: '';
      position: absolute;
      left: 100%;
      bottom: 41%;
      transform: translate(-50%, -50%) rotate(225deg);
      width: 15px;
      height: 15px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      border-style: none none solid solid
    }
  .demo-breadcrumb-separator {
    padding-left: 16px;
    line-height: 42px;
    color: #7f7f7f;
    font-size: 18px;
    font-weight: 400;
  }
  
  .iten {
    margin-top: 40px;
    text-align: left;
  }
  
  .itn {
    margin-top: 63px;
    margin-bottom: 24px;
  }
  
  .nav-content {
    width: inherit;
    margin: 0 auto;
  }
  .step_box{
    display: flex;
    justify-content: center;
    height: 150px;
    &.isright{
      flex-direction:row-reverse;
      .cover_text{
        text-align: right !important;
      }
    }
    &.isfirst{
      .icon_dot::after{
        height: 50%;
        top: unset;
        bottom: 0;
      }
    }
    &.islast{
      .icon_dot::after{
        height: 50%;
      }
    }
    .flex_1{
      width: 350px;
      &.cover_img{
        display: flex;
        align-items: center;
      }
      &.cover_text{
        text-align: left;
        display: flex;
        align-content: center;
        flex-wrap: wrap;
        >p{
          width: 100%;
          margin: 5px 0;
          &:first-child{
            font-size: 20px;
            color: #000;
            margin-top: 25px;
          }
          &:nth-child(2){
            font-size: 14px;
            color: #656565;
          }
        }
      }
    }
    .icon_dot{
      margin: 0 80px;
      display: flex;
      align-items: center;
      position: relative;
      &::after{
        content: "";
        position: absolute;
        height: 100%;
        width: 1px;
        background: #BCBCBC;
        top: 0;
        left: 0;
        right: 0;
        margin: auto;
      }
      img{
        width: 12px;
        height: 12px;
        position: relative;
        z-index: 9;
        display: block;
        margin-bottom: 2px;
      }
    }
  }
  .circle{
    width: 12px;
    height: 12px;
    background: #FFFFFF;
    border: 2px solid #B8B8B8;
  }
  
    .firstCiropp {
      width: 200px;
      height: 70px;
      border-radius: 8px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      position: relative;
      margin-bottom: 94px;
      border-radius: 20px;
    }
 
    .firstCiropp::after {
      content: '';
      position: absolute;
      top: 100%;
      left: 50%;
      transform: translate(-50%, -50%) rotate(-45deg);
      /*三角形的方向*/
      width: 15px;
      height: 15px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      border-style: none none solid solid
    }
    .leftCiropp {
      width: 342px;
      height: 125px;
      border-radius: 8px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      position: relative;
    }
 
    .leftCiropp::after {
      content: '';
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%) rotate(45deg);
      width: 15px;
      height: 15px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      border-style: none none solid solid
    }
    .rightCiropp {
      width: 342px;
      height: 125px;
      border-radius: 8px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      position: relative;
    }
 
    .rightCiropp::after {
      content: '';
      position: absolute;
      left: 100%;
      bottom: 41%;
      transform: translate(-50%, -50%) rotate(225deg);
      width: 15px;
      height: 15px;
      background: #FFF;
      border: 1px solid #D1D1D1;
      border-style: none none solid solid
    }
    .yuan{
        width: 12px;
        height: 12px;
        position: relative;
        background: #fff;
        z-index: 9;
        display: block;
        margin-bottom: 2px;
        background-image: url('../../../static//ligong/yuan.webp');
        background-size: 100% 100%;
    }
    .startItem{
      text-align: center;
      color: #222222;
      font-size: 14px;
      font-weight: 600;
    }
    .ywcRight{
      float: left;
      width: 32px;
      height: 18px;
      background: #00B55A;
      border-radius: 3px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      margin-right: 8px;
      margin-top: 5px;
    }
    .ywcLeft{
      float: left;
      width: 32px;
      height: 18px;
      background: #00B55A;
      border-radius: 3px;
      color: #fff;
      font-size: 12px;
      text-align: center;
      margin-top: 5px;
    }
    .itemTitle{
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 18px;
      color: #222222;
      text-align: right;
      float: left;
      max-width: 260px;
      white-space: nowrap;      /* 确保文本在一行内显示 */
      overflow: hidden;         /* 超出容器的文本隐藏 */
      text-overflow: ellipsis
    }
    .itemTitle1{
      font-family: PingFangSC-SNaNpxibold;
      font-weight: 600;
      font-size: 18px;
      color: #222222;
      text-align: right;
      float: left;
      max-width: 260px;
      white-space: nowrap;      /* 确保文本在一行内显示 */
      overflow: hidden;         /* 超出容器的文本隐藏 */
      text-overflow: ellipsis;
      margin-right:8px
    }
    .itemData{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: right;
      margin-bottom: 12px;
    }
    .itemPerson{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: right;
    }
    .itemData1{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: left;
      margin-bottom: 12px;
    }
    .itemPerson1{
      font-weight: 400;
      font-size: 16px;
      color: #7F7F7F;
      text-align: left;
    }

</style>


// WEBPACK FOOTER //
// src/components/inside/workProgressDetail.vue